/**
 * Card treatment, driven entirely by tokens:
 * - adults/teens (Fjord): flat surface with a hairline, no shadow
 * - kid profiles (building-block look chosen by the kids): ink outline + hard offset shadow
 */
export const cardSurface =
  'bg-surface-raised border-(length:--shh-card-border) border-border-card shadow-card';

/**
 * Press feedback for tappable cards and buttons. With the block look the element sinks into its
 * shadow (offset from tokens); in the flat look the offset is 0 and a slight scale remains.
 */
export const pressable = [
  'transition duration-(--shh-motion-duration-quick) ease-standard',
  'data-pressed:scale-98 data-pressed:shadow-none',
  'data-pressed:translate-x-(--shh-card-press-offset) data-pressed:translate-y-(--shh-card-press-offset)',
].join(' ');
